import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { format } from 'util';
import { redact } from '@nerdwallet/redact';
import { logToSentry } from '../sentry';
import { Level, LevelPriority } from '../constants';
import { getLoggingLevel } from './loggingLevel';
import isInDev from '../isInDev';
import isOnServer from '../isOnServer';
/**
 * Should this logging statement produce output?
 * @private
 */

export var shouldLog = function shouldLog(level, localLevel) {
  return LevelPriority[level] >= LevelPriority[localLevel !== null && localLevel !== void 0 ? localLevel : getLoggingLevel()];
};

/**
 * This will log to the console based on the supplied log level, and the global log level.
 * Note that the global log level is initialised according to the NODE_ENV and existence of
 * proces.browser. Once initialised, it can be changed by using setLoggingLevel.
 *
 * - We will always log to the browser console as well as the server console in dev mode (and this is not redacted).
 * - We will log nothing to the browser console in non-dev mode.
 * - We will log some stuff to the server console in non-dev mode (this is redacted).
 * @private
 * @param level - log or error.
 * @param messages - varargs, same as console.log or console.error.
 */
export var logInner = function logInner(args) {
  var level = args.level,
      messages = args.messages,
      localLevel = args.localLevel,
      loggerName = args.loggerName,
      _args$tags = args.tags,
      tags = _args$tags === void 0 ? {} : _args$tags;

  if (shouldLog(level, localLevel)) {
    var dateString = new Date().toISOString();

    if (!isOnServer()) {
      var _console;

      // In client, we construct a readable message and use the proper console methods to log it.
      var consoleArgs = [dateString];
      if (loggerName) consoleArgs.push("[".concat(loggerName, "]"));
      consoleArgs.push.apply(consoleArgs, _toConsumableArray(messages));

      (_console = console)[level].apply(_console, consoleArgs);
    } else {
      // Always log on the server.
      // This is designed to match bole's output, which is already handled by elk
      // and pretty printed in local dev via garnish by most apps
      var effectiveLevel = level === Level.error && !isInDev() ? Level.error : Level.log;
      console[effectiveLevel](JSON.stringify({
        time: dateString,
        level: level,
        message: format.apply(void 0, _toConsumableArray(isInDev() ? redact(messages) : messages)),
        name: loggerName,
        url: tags.endpoint,
        tags: _objectSpread({
          loggerName: loggerName
        }, tags)
      }));
    }
  } // Notify Sentry of anything that's logged at Error level in non-dev mode


  if (!isInDev() && level === Level.error) {
    logToSentry(messages);
  }
};